var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestMobileMoreSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 3,
  viewBox: "0 0 12 3",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M10.421 0C11.293 0 12 .672 12 1.5S11.293 3 10.421 3s-1.579-.672-1.579-1.5S9.55 0 10.422 0M6 0c.872 0 1.579.672 1.579 1.5S6.872 3 6 3s-1.579-.672-1.579-1.5S5.128 0 6 0M1.579 0c.872 0 1.579.672 1.579 1.5S2.45 3 1.578 3C.708 3 0 2.328 0 1.5S.707 0 1.579 0"
})));
export default SvgPinterestMobileMoreSm;